"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ReorderDown: ['reorder-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.248,17h-1.5a.25.25,0,0,1-.25-.25V3a1,1,0,0,0-2,0V16.75a.25.25,0,0,1-.25.25h-1.5a.75.75,0,0,0-.6,1.2l2.753,3.67a.75.75,0,0,0,1.2,0l2.75-3.667h0A.749.749,0,0,0,22.248,17Z', 'M0.998 0.000 L11.998 0.000 L11.998 11.000 L0.998 11.000 Z', 'M10,13H8.5a1,1,0,1,0,0,2h1a.5.5,0,0,1,.5.5v1a1,1,0,0,0,2,0V15A2,2,0,0,0,10,13Z', 'M11,19.5a1,1,0,0,0-1,1v1a.5.5,0,0,1-.5.5h-1a1,1,0,1,0,0,2H10a2,2,0,0,0,2-2V20.5A1,1,0,0,0,11,19.5Z', 'M4.5,22h-1a.5.5,0,0,1-.5-.5v-1a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H4.5a1,1,0,1,0,0-2Z', 'M5.5,14a1,1,0,0,0-1-1H3a2,2,0,0,0-2,2v1.5a1,1,0,0,0,2,0v-1a.5.5,0,0,1,.5-.5h1A1,1,0,0,0,5.5,14Z']],
  ReorderUp: ['reorder-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.85,5.8h0L20.1,2.131a.772.772,0,0,0-1.2,0L16.148,5.8a.749.749,0,0,0,.6,1.2h1.5a.25.25,0,0,1,.25.25V21a1,1,0,0,0,2,0V7.25a.25.25,0,0,1,.25-.25h1.5A.75.75,0,0,0,22.85,5.8Z', 'M0.999 13.000 L11.999 13.000 L11.999 24.000 L0.999 24.000 Z', 'M11,6.5a1,1,0,0,0-1,1v1a.5.5,0,0,1-.5.5h-1a1,1,0,0,0,0,2H10a2,2,0,0,0,2-2V7.5A1,1,0,0,0,11,6.5Z', 'M10,0H8.5a1,1,0,1,0,0,2h1a.5.5,0,0,1,.5.5v1a1,1,0,0,0,2,0V2A2,2,0,0,0,10,0Z', 'M2,4.5a1,1,0,0,0,1-1v-1A.5.5,0,0,1,3.5,2h1a1,1,0,0,0,0-2H3A2,2,0,0,0,1,2V3.5A1,1,0,0,0,2,4.5Z', 'M3,11H4.5a1,1,0,0,0,0-2h-1A.5.5,0,0,1,3,8.5v-1a1,1,0,0,0-2,0V9A2,2,0,0,0,3,11Z']]
};
exports["default"] = _default;